import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PerCardInfo } from '../../../../../components/custom_components/CardInfo'
import PerText from '../../../../../components/custom_components/Text'
import { MeetingModal } from './MeetingModal'

interface MeetingModalReviewerProps {
  visible: boolean
  onCancel: () => void
  onConfirm: () => void
}

const MeetingModalReviewer: FC<MeetingModalReviewerProps> = ({ visible, onCancel, onConfirm }) => {
  const [t] = useTranslation()

  return (
    <MeetingModal
      title={t('appraisalMeeting.stepConclusion.modal.reviewer.header')}
      visible={visible}
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmText={t('appraisalMeeting.stepNotes.confirmBtn')}
    >
      <PerCardInfo heading={t('appraisalMeeting.stepConclusion.modal.reviewer.cardHeader')}>
        <PerText appearance="info">{t('appraisalMeeting.stepConclusion.modal.reviewer.cardDescription')}</PerText>
      </PerCardInfo>
    </MeetingModal>
  )
}
export { MeetingModalReviewer }
